export const LEARN_MORE_LINK =
	'https://confluence.atlassian.com/display/AdminJIRACloud/Jira+Cloud+plans';

export const WORKFLOW_EDIT_PERMISSION_LEARN_MORE_LINK =
	'https://support.atlassian.com/jira-cloud-administration/docs/permissions-for-company-managed-projects/#Edit-Workflows';

export const UPGRADE_LINK = '/admin/billing/applications';
